import HeaderMobile from '@components/LayoutCheckout/HeaderMobile';
import HeaderDesktop from '@components/LayoutCheckout/HeaderDesktop';
import React from 'react';
import { ICheckoutSteps } from '@hooks/useCheckoutSteps';

const HeaderCheckout = ({ step, title }) => {
  const isStepperDisplayed = step !== ICheckoutSteps.INTERMEDIARY;

  return (
    <>
      <HeaderMobile
        step={step}
        title={title}
        isStepperDisplayed={isStepperDisplayed}
      />
      <HeaderDesktop step={step} isStepperDisplayed={isStepperDisplayed} />
    </>
  );
};

export default HeaderCheckout;
